// src/ui/nameColor.js — the colour a member's name is written in.
//
// 🟢 THE SAME HASH OVER THE SAME PALETTES AS THE PHONE (MessageBubble's
//    `senderNameColor`), so a member who is teal in the app is teal here.
//
// 🟥 IT LIVES IN ITS OWN MODULE because three places need it now — the bubble in
//    the conversation, the member row in group settings, and the tag editor's
//    live preview — and a second copy of a hash is a second answer. The preview
//    exists precisely to show what the real thing will look like; if it computed
//    the colour separately it could be confidently wrong.
export const NAME_LIGHT = ['#1F6FD0', '#0F8A5F', '#C0397A', '#B5761B', '#6B4FCF', '#0E8A93', '#C4553A', '#4B8B2B'];
export const NAME_DARK = ['#7FB8FF', '#7BD8B0', '#F2A9C4', '#F5C77E', '#B9A6F5', '#78D2D8', '#F09A86', '#A8D28A'];

export function nameColor(uid) {
  const s = String(uid || '');
  if (!s) return 'var(--text-3)';
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  const dark = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches;
  const pal = dark ? NAME_DARK : NAME_LIGHT;
  return pal[Math.abs(h) % pal.length];
}
